import axios from "axios";

// export const baseURL = "http://localhost:5070/";
export const baseURL = "/";
//export const baseURL = "https://vtz.myfootball11.com/";

const headers = {
  "Content-Type": "application/json",
  "x-auth": "M@#weh@##dhASD2627@#2024",
};

export const subApi = async (data) => {
  try {
    const response = await axios.post(`${baseURL}vtzfbApi/auth/sub`, data);
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};

export const getPacksApi = async (userId) => {
  try {
    if (userId != null) {
      const response = await axios.get(
        `${baseURL}vtzfbApi/auth/getPacks/${userId}`,
      );
      return response.data;
    } else {
      const response = await axios.get(`${baseURL}vtzfbApi/auth/getPacks`);
      return response.data;
    }
  } catch (e) {
    throw e.response.data;
  }
};

export const getSubStatusApi = async (data, token) => {
  try {
    headers.Authorization = "Bearer " + token;
    const response = await axios.post(
      `${baseURL}vtzfbApi/auth/getSubStatus`,
      data,
      { headers: headers },
    );
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};

export const unsubApi = async (token) => {
  try {
    headers.Authorization = "Bearer " + token;
    const response = await axios.post(`${baseURL}vtzfbApi/user/unsub`, "", {
      headers: headers,
    });
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};

export const loginApi = async (msisdn) => {
  const response = await axios.post(`${baseURL}api/v1/login`, {
    msisdn: msisdn,
  });
  return response;
};

export const upcomingMatchesApi = async (token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/get-upcoming-matches`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const fetchUpcomingMatchDetailsApi = async (id, token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/get-upcoming-match-details/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const saveUserTeamApi = async (
  match_fixture_id,
  team,
  match_date_time,
  match_venue_name,
  match_venue_city,
  league_id,
  league_name,
  league_image,
  home_team_id,
  home_team_name,
  home_team_image,
  away_team_id,
  away_team_name,
  away_team_image,
  token,
) => {
  const response = await axios.post(
    `${baseURL}api/v1/protected/save-user-team`,
    {
      match_fixture_id,
      team,
      match_date_time,
      match_venue_name,
      match_venue_city,
      league_id,
      league_name,
      league_image,
      home_team_id,
      home_team_name,
      home_team_image,
      away_team_id,
      away_team_name,
      away_team_image,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response;
};

export const editUserTeamApi = async (
  match_fixture_id,
  team,
  match_date_time,
  match_venue_name,
  match_venue_city,
  league_id,
  league_name,
  league_image,
  home_team_id,
  home_team_name,
  home_team_image,
  away_team_id,
  away_team_name,
  away_team_image,
  token,
) => {
  const response = await axios.post(
    `${baseURL}api/v1/protected/edit-user-team`,
    {
      match_fixture_id,
      team,
      match_date_time,
      match_venue_name,
      match_venue_city,
      league_id,
      league_name,
      league_image,
      home_team_id,
      home_team_name,
      home_team_image,
      away_team_id,
      away_team_name,
      away_team_image,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response;
};

export const userMatchesApi = async (token) => {
  const response = await axios.get(`${baseURL}api/v1/protected/user-matches`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const liveMatchesApi = async (token) => {
  const response = await axios.get(`${baseURL}api/v1/protected/live-matches`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const matchDetailsApi = async (match_fixture_id, token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/get-match-details/${match_fixture_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const userFantasyTeamApi = async (match_fixture_id, token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/user-fantasy-team/${match_fixture_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const fantasyGameLeaderboardApi = async (match_fixture_id, token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/fantasy-match-leaderboard/${match_fixture_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const saveUserPredictionsApi = async (
  match_fixture_id,
  predictions,
  match_date_time,
  match_venue_name,
  match_venue_city,
  league_id,
  league_name,
  league_image,
  home_team_id,
  home_team_name,
  home_team_image,
  away_team_id,
  away_team_name,
  away_team_image,
  token,
) => {
  const response = await axios.post(
    `${baseURL}api/v1/protected/save-user-predictions`,
    {
      match_fixture_id,
      predictions,
      match_date_time,
      match_venue_name,
      match_venue_city,
      league_id,
      league_name,
      league_image,
      home_team_id,
      home_team_name,
      home_team_image,
      away_team_id,
      away_team_name,
      away_team_image,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const editUserPredictionsApi = async (
  match_fixture_id,
  predictions,
  match_date_time,
  match_venue_name,
  match_venue_city,
  league_id,
  league_name,
  league_image,
  home_team_id,
  home_team_name,
  home_team_image,
  away_team_id,
  away_team_name,
  away_team_image,
  token,
) => {
  const response = await axios.post(
    `${baseURL}api/v1/protected/edit-user-predictions`,
    {
      match_fixture_id,
      predictions,
      match_date_time,
      match_venue_name,
      match_venue_city,
      league_id,
      league_name,
      league_image,
      home_team_id,
      home_team_name,
      home_team_image,
      away_team_id,
      away_team_name,
      away_team_image,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const getUserPredictionsApi = async (match_fixture_id, token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/get-user-predictions/${match_fixture_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const getPredictionLeaderboardApi = async (match_fixture_id, token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/prediction-game-leaderboard/${match_fixture_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const monthlyLeaderboardApi = async (token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/monthly-leaderboard`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const getPlayerPointsApi = async (
  match_fixture_id,
  player_id,
  token,
) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/get-player-points?match_fixture_id=${match_fixture_id}&player_id=${player_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const getProfileApi = async (token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/get-user-profile`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const editProfileApi = async (formData, token) => {
  const response = await axios.post(
    `${baseURL}api/v1/protected/edit-profile`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const subscriptionInfoApi = async (token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/subscription-info`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const winningHistoryApi = async (token) => {
  const response = await axios.get(
    `${baseURL}api/v1/protected/winning-history`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};
